import { MenuItem } from '@material-ui/core';
import { Autocomplete, Skeleton } from '@mui/material';
import styled from 'styled-components';

export const ContainerGroupsPage = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContainerGroupsForm = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    gap: 0.5rem;
`;

export const HeaderWrapperGroupsPage = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    gap: 1.5rem;
    width: calc(100% - 2rem);
    @media (max-width: 800px) {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const CenterSearchMember = styled.div`
    display: flex;
    width: 100%;
    justify-content: start;
    border-radius: 10px;
    align-self: center;
    input,
    fieldset {
        border-radius: 10px;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #a8a8a8;
        border-radius: 10px;
    }
    .MuiAutocomplete-endAdornment {
        align-content: space-evenly;
    }
`;

export const ButtonsWrapperGroupsPage = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    padding: 1rem;
    height: calc(60px - 2rem);
    width: calc(max-content - 2rem);
    background-color: #f9f9f9;
    box-shadow: 0px 0px 9px -2px rgba(219, 219, 219, 0.75);
    -webkit-box-shadow: 0px 0px 9px -2px rgba(219, 219, 219, 0.75);
    -moz-box-shadow: 0px 0px 9px -2px rgba(219, 219, 219, 0.75);
    border-radius: 1rem;
`;

export const ImageStyle = styled.img`
    width: 250px;
    height: auto;
    margin-top: 1rem;
`;

export const TextMessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    text-align: center;
`;

export const ContainerFormGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${p => (p.formGroup ? 'center' : '')};
    row-gap: ${p => (p.formGroup ? '2rem' : '')};
    padding: 1.5rem;
    min-width: ${p => (p.formGroup ? '320px' : '768px')};
    max-width: ${p => (p.formGroup ? '320px' : '')};
`;

export const FormAddGroupContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: calc(100% - 2rem);
    padding: 0 0.5rem;
`;

export const FormAddGroupWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: end;
    width: 100%;
    gap: 0.5rem;
    height: 85px;
    div {
        height: 100%;
    }
`;

export const AllParticipantsCheck = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-end;
    height: 35px !important;
    width: 150px;
    font-size: 0.8rem;
    border-radius: 10px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.06);
    padding: 0.8rem 1rem;
`;

export const MenuItemStyle = styled(MenuItem)`
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
`;

// Skeleton
export const ContainerSkt = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
`;

export const HeaderWrapperSkt = styled.div`
    display: flex;
    align-items: center;
    column-gap: 1.5rem;
`;

export const SkeletonStyled = styled(Skeleton)`
    border-radius: 1rem;
`;

export const AutocompleteStyled = styled(Autocomplete)`
    width: 100%;
    border-radius: 10px;
    .MuiAutocomplete-inputRoot {
        height: 100%;
    }
`;

export const LeaderGroupContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 1rem;
    padding: 1rem;
    border-radius: 10px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.06);

    background-color: #fafafa;
`;
